import { render } from "./CustomerComplaint.vue?vue&type=template&id=b9d7ecb0&scoped=true"
import script from "./CustomerComplaint.vue?vue&type=script&lang=js"
export * from "./CustomerComplaint.vue?vue&type=script&lang=js"

import "./CustomerComplaint.vue?vue&type=style&index=0&id=b9d7ecb0&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d7ecb0"]])

export default __exports__